function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import dayGridPlugin from '@fullcalendar/daygrid';
import listPlugin from '@fullcalendar/list';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import { clientRemindDetailApi } from '@/api/enterprise';
import { scheduleListApi, scheduleStatusApi } from '@/api/user';
import { toGetWeek } from '@/utils/format';
import { configRuleApproveApi } from '@/api/config';
export default {
  name: 'WorkDealt',
  components: {
    calendarBar: function calendarBar() {
      return import('./components/calendarBar');
    },
    dialogForm: function dialogForm() {
      return import('@/views/user/workDealt/components/index');
    },
    FullCalendar: function FullCalendar() {
      return import('@fullcalendar/vue');
    },
    addTodo: function addTodo() {
      return import('./components/addTodo');
    },
    contractDialog: function contractDialog() {
      return import('@/views/customer/contract/components/contractDialog');
    },
    recordUpload: function recordUpload() {
      return import('@/views/customer/list/components/recordUpload');
    },
    calendarDetails: function calendarDetails() {
      return import('./components/calendarDetails');
    },
    editExamine: function editExamine() {
      return import('@/views/user/examine/components/editExamine');
    }
  },
  data: function data() {
    var _this = this;
    return {
      loading: false,
      calendarApi: null,
      title: '',
      time: '1',
      cid: null,
      dialogVisible: false,
      configContract: {},
      formInfo: {
        avatar: '',
        type: 'add',
        show: 1,
        data: {},
        follow_id: 0
      },
      fromList: [{
        text: this.$t('access.day'),
        val: '1'
      }, {
        text: this.$t('user.work.week'),
        val: '2'
      }, {
        text: this.$t('user.work.month'),
        val: '3'
      }],
      start_time: '',
      end_time: '',
      dateInfo: {},
      type: [],
      period: 1,
      calendarOptions: {
        height: 'calc(100vh - 232px)',
        eventColor: '',
        initialDate: this.$moment().format('yyyy-MM-DD HH:mm:ss'),
        plugins: [dayGridPlugin, interactionPlugin, timeGridPlugin, listPlugin],
        handleWindowResize: true,
        displayEventTime: false,
        slotDuration: '00:60:00',
        scrollTime: '00:00:00',
        slotMinTime: '00:00:00',
        //设置显示的时间从几点开始
        headerToolbar: {
          // 日历头部按钮位置
          left: '',
          center: 'prev title next',
          right: ''
        },
        buttonText: {
          month: '月',
          week: '周',
          day: '天'
        },
        // type: 'resourceTimeline',
        allDaySlot: true,
        // eventLimit: true,
        dayMaxEventRows: 5,
        allDayText: '',
        moreLinkContent: this.moreLinkContent,
        weekends: true,
        nowIndicator: true,
        // weekMode: 'fixed',
        weekNumbers: false,
        slotLabelFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false // 设置时间为24小时
        },
        selectable: true,
        // userId: '',
        displayEventEnd: false,
        //所有视图显示结束时间
        initialView: 'timeGridDay',
        // 设置默认显示月，可选周、日
        dateClick: this.handleDateClick,
        // eventClick: this.handleEventClick,

        customButtons: {
          next: {
            text: 'PREV',
            click: function click() {
              _this.next();
            }
          },
          prev: {
            text: 'PREV',
            click: function click() {
              _this.prev();
            }
          }
        },
        events: [],
        slotEventOverlap: false,
        // allowCalEventOverlap: false,

        eventOverlap: false,
        locale: 'zh-cn',
        // 设置语言
        weekNumberCalculation: 'ISO' // 周数
      },
      detailedData: {},
      parameterData: {
        contract_id: '',
        customer_id: '',
        invoice_id: '',
        bill_id: ''
      },
      leftTime: '',
      buildData: [],
      item: {},
      status: 0
    };
  },
  mounted: function mounted() {
    var _this2 = this;
    this.userId = JSON.parse(localStorage.getItem('userInfo')).userId;
    this.formInfo.avatar = JSON.parse(localStorage.getItem('userInfo')).avatar;
    this.getConfigApprove();
    setTimeout(function () {
      if (_this2.$refs.calendar) {
        _this2.calendarApi = _this2.$refs.calendar.getApi();
        _this2.dayRender();
        _this2.title = _this2.$moment(_this2.calendarApi.view.currentStart).format('YYYY-MM-DD');
      }
    }, 400);
    this.start_time = this.title + ' 00:00:00';
    this.end_time = this.title + ' 23:59:59';
    this.removeTitle();
  },
  methods: {
    // 点击有事件的单元格
    handleEventClick: function handleEventClick(e) {
      this.$refs.calendarDetails.openBox(e.event.extendedProps);
    },
    recordChange: function recordChange() {
      this.dialogVisible = false;
      this.getList();
    },
    getConfigApprove: function getConfigApprove() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return configRuleApproveApi(0);
            case 2:
              result = _context.sent;
              _this3.buildData = result.data;
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    // 修改状态
    putStatus: function putStatus(text, status, item) {
      var _this4 = this;
      ;
      this.item = item.extendedProps, this.status = status;
      if (item.extendedProps.cid_value == 3 || item.extendedProps.cid_value == 4) {
        var id = item.extendedProps.bill_id.bill_id !== 0 ? item.extendedProps.bill_id.bill_id : item.extendedProps.bill_id.remind_id;
        if (status == 3) {
          clientRemindDetailApi(id).then(function (res) {
            res.data.id = item.extendedProps.bill_id.remind_id;
            _this4.parameterData.customer_id = res.data.eid;
            _this4.parameterData.contract_id = res.data.cid;
            if (res.data.types == 0) {
              var data = {
                id: _this4.buildData.contract_refund_switch
              };
              _this4.$refs.editExamine.openBox(data, res.data.cid, 'contract_refund_switch', item, status);
            } else {
              var _data = {
                id: _this4.buildData.contract_renew_switch
              };
              _this4.$refs.editExamine.openBox(_data, res.data.cid, 'contract_renew_switch', item, status);
            }
          });
        } else {
          // this.scheduleRecord(item.extendedProps, status)
        }
      } else if (item.extendedProps.cid_value == 2) {
        if (item.extendedProps.finish == 3) {
          return false;
        }
        this.formInfo.follow_id = item.extendedProps.bill_id ? item.extendedProps.bill_id.follow_id : 0;
        this.formInfo.data.id = item.extendedProps.link_id;
        this.dialogVisible = true;
      } else {
        this.scheduleRecord(item.extendedProps, status);
      }
    },
    // 提醒状态
    scheduleRecord: function scheduleRecord(data, status) {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var info, id;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              info = {
                status: status ? status : _this5.status,
                start: data ? data.start_time : _this5.item.start_time,
                end: data ? data.end_time : _this5.item.end_time
              };
              id = data ? data.itemId : _this5.item.itemId;
              _context2.next = 4;
              return scheduleStatusApi(id, info);
            case 4:
              _context2.next = 6;
              return _this5.getList();
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 点击空白单元格
    handleDateClick: function handleDateClick(e) {
      this.detailedData = {
        startDate: this.$moment(e.date).format('YYYY-MM-DD'),
        startTime: this.$moment(e.date).format('HH:mm:ss'),
        endDate: this.$moment(e.date).format('YYYY-MM-DD'),
        time: this.$moment(e.date).format('YYYY-MM-DD HH:mm:ss')
      };
      this.$refs.addTodo.openBox(this.detailedData);
    },
    // 修改当天系统背景颜色
    dayRender: function dayRender() {
      document.documentElement.style.setProperty("--fc-today-bg-color", '#fff');
      var dayTime = document.querySelectorAll('.fc-timegrid-slot-label-cushion');
      dayTime[0].classList.add('fcTime');
      document.querySelectorAll('.fc-button-primary').forEach(function (li) {
        return li.setAttribute('title', '');
      });
    },
    // 更多日程
    moreLinkContent: function moreLinkContent(e) {
      return '还有' + e.num + '个日程';
    },
    day: function day() {
      this.period = 1;
      this.calendarApi.changeView('timeGridDay');
      this.getList();
      this.removeTitle();
      this.dayRender();
    },
    month: function month() {
      this.period = 3;
      this.calendarApi.changeView('dayGridMonth');
      this.getList();
      this.removeTitle();
    },
    week: function week() {
      this.period = 2;
      this.calendarApi.changeView('timeGridWeek');
      this.getList();
      this.removeTitle();
      this.dayRender();
    },
    // 上一天
    prev: function prev() {
      this.calendarApi.prev();
      this.getList();
      if (this.period == 2) {
        var date = this.$refs.calendarBar.value;
        this.$refs.calendarBar.value = this.$moment(this.$moment(date).subtract(7, 'd')).format('YYYY-MM-DD');
      } else {
        this.$refs.calendarBar.value = this.$moment(this.calendarApi.view.currentStart).format('YYYY-MM-DD');
      }
    },
    removeTitle: function removeTitle() {
      var row = null;
      setTimeout(function () {
        row = document.querySelectorAll('.fc-daygrid-day-bottom a');
        for (var i = 0; i < row.length; i++) {
          row[i].title = '';
        }
      }, 300);
    },
    // 下一天
    next: function next() {
      this.calendarApi.next();
      this.getList();
      if (this.period == 2) {
        var date = this.$refs.calendarBar.value;
        this.$refs.calendarBar.value = this.$moment(this.$moment(date).add(7, 'd'));
      } else {
        this.$refs.calendarBar.value = this.$moment(this.calendarApi.view.currentStart).format('YYYY-MM-DD');
      }
    },
    getList: function getList() {
      var _this6 = this;
      this.loading = true;
      if (this.period == 1) {
        this.start_time = this.$moment(this.calendarApi.view.currentStart).format('YYYY-MM-DD') + ' 00:00:00';
        this.end_time = this.$moment(this.calendarApi.view.currentStart).format('YYYY-MM-DD') + ' 23:59:59';
      } else if (this.period == 2) {
        this.start_time = this.$moment(this.calendarApi.view.currentStart).format('YYYY-MM-DD') + ' 00:00:00';
        this.end_time = this.$moment(this.calendarApi.view.currentEnd).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59';
      } else {
        this.start_time = this.$moment(this.calendarApi.view.activeStart).format('YYYY-MM-DD') + ' 00:00:00';
        this.end_time = this.$moment(this.calendarApi.view.currentEnd).subtract(1, 'days').format('YYYY-MM-DD') + ' 23:59:59';
      }
      var data = {
        start_time: this.start_time,
        end_time: this.end_time,
        period: this.period,
        cid: this.cid
      };
      scheduleListApi(data).then(function (res) {
        _this6.loading = false;
        var newArr = [];
        res.data.map(function (item) {
          var start_time = item.start_time;
          var end_time = item.end_time;
          if (_this6.$moment(item.end_time).format('YYYY-MM-DD') != _this6.$moment(item.start_time).format('YYYY-MM-DD')) {
            item.all_day = true;
            item.end_time = _this6.$moment(item.end_time).format('YYYY-MM-DD') + ' 24:00:00';
          } else if (_this6.$moment(item.end_time).format('YYYY-MM-DD') == _this6.$moment(item.start_time).format('YYYY-MM-DD') && item.all_day == 1) {
            item.all_day = true;
            item.end_time = _this6.$moment(item.end_time).format('YYYY-MM-DD') + ' 24:00:00';
          } else if (item.all_day == 0) {
            item.all_day = false;
          }
          if (item.user.length == 0) {
            item.user.push(item.master);
          }
          var avatar = JSON.parse(localStorage.getItem('userInfo')).avatar;
          newArr.push({
            start: item.start_time,
            end: item.end_time,
            allDay: item.all_day,
            title: item.title,
            avatar: item.master.avatar || avatar,
            content: item.content,
            start_time: start_time,
            end_time: end_time,
            color: _this6.getColor(item.color, '0.1'),
            textColor: item.color,
            show: _this6.findItem(item.user, 'id', item.master.id),
            finish: item.finish,
            itemId: item.id,
            cid_value: item.cid,
            overlap: false,
            bill_id: item.relation || '',
            link_id: item.link_id
          });
        });
        _this6.calendarOptions.events = newArr;
        _this6.$refs.calendarBar.getList();
      });
    },
    // 方法
    findItem: function findItem(arr, key, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i].id === val || arr[i].id == this.userId) {
          return 2;
        }
      }
      return -1;
    },
    getWeek: function getWeek(date) {
      // 参数时间戳
      return toGetWeek(date);
    },
    editFn: function editFn(id, type, date) {
      var data = {
        id: id,
        type: type,
        edit: true,
        date: date
      };
      this.$refs.addTodo.openBox(data);
    },
    handleDate: function handleDate(data, val) {
      var _this7 = this;
      this.cid = data.type;
      this.leftTime = data.time;
      if (val) {
        this.calendarApi.gotoDate(data.time);
      }
      setTimeout(function () {
        _this7.calendarApi = _this7.$refs.calendar.getApi();
        _this7.getList();
      }, 300);
    },
    selectChange: function selectChange(e) {
      this.time = e;
      if (this.time == 1) {
        this.day();
      } else if (this.time == 2) {
        this.week();
      } else {
        this.month();
      }
    },
    addSchedule: function addSchedule() {
      this.$refs.addTodo.openBox();
    },
    // 颜色转换函数
    getColor: function getColor(thisColor, thisOpacity) {
      var theColor = thisColor.toLowerCase();
      var r = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      if (theColor && r.test(theColor)) {
        if (theColor.length === 4) {
          var sColorNew = '#';
          for (var i = 1; i < 4; i += 1) {
            sColorNew += theColor.slice(i, i + 1).concat(theColor.slice(i, i + 1));
          }
          theColor = sColorNew;
        }
        var sColorChange = [];
        for (var i = 1; i < 7; i += 2) {
          sColorChange.push(parseInt('0x' + theColor.slice(i, i + 2)));
        }
        return 'rgba(' + sColorChange.join(',') + ',' + thisOpacity + ')';
      }
    }
  }
};